import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';
import setupCompletenessBannerBg from '../../../../components/SetupCompleteness/SetupCompletenessBar/assets/setup-completeness-banner-dark2.svg';

const theme: ThemeApp['appComponents']['setupCompleteness'] = {
  setupCompletenessBar: {
    bannerCompose: {
      borderBottom: themeUi.semantic.color.border.secondary800,
      backgroundColor: themeUi.semantic.color.background.primary950,
      backgroundImage: `url(${setupCompletenessBannerBg})`
    },
    bannerMessage: {
      color: themeUi.semantic.color.text.secondary50
    }
  },

  setupCompletenessButton: {
    icon: {
      color: themeUi.semantic.color.icon.secondary50
    },
    badge: {
      border: themeUi.semantic.color.text.secondary900,
      backgroundColor: themeUi.semantic.color.text.success500
    }
  },

  setupCompletenessDrawer: {
    setupCompletenessDrawer: {
      title: {
        color: themeUi.semantic.color.text.secondary50
      },
      caption: {
        color: themeUi.semantic.color.text.secondary50
      },
      containerFooter: {
        backgroundColor: themeUi.semantic.color.background.secondary800
      },
      footerText: {
        color: themeUi.semantic.color.text.secondary100
      },
      footerLink: {
        color: themeUi.semantic.color.text.primary300
      },
      line: {
        backgroundColor: themeUi.semantic.color.background.secondary800
      },
      collapseContainer: {
        backgroundColor: themeUi.semantic.color.background.secondary990,
        header: {
          backgroundColor: themeUi.semantic.color.background.secondary800,
          color: themeUi.semantic.color.text.secondary50,
          fill: themeUi.semantic.color.icon.secondary50,
          fontFamily: themeUi.core.font.fontFamily.regular
        }
      },
      collapseTitleCompleted: {
        color: themeUi.semantic.color.text.success600,
        backgroundColor: themeUi.semantic.color.background.success900,
        border: themeUi.semantic.color.border.success800
      },
      collapseTitleCompletedIcon: {
        fill: themeUi.semantic.color.icon.success600
      }
    },

    components: {
      setupCompletenessDrawerLink: {
        container: {
          backgroundColor: themeUi.semantic.color.background.secondary900,
          border: themeUi.semantic.color.border.secondary800
        },
        title: {
          color: themeUi.semantic.color.text.primary300
        },
        description: {
          color: themeUi.semantic.color.text.secondary100
        }
      },

      setupCompletenessDrawerTask: {
        container: {
          color: themeUi.semantic.color.text.secondary100
        },
        icon: {
          checkedFill: themeUi.semantic.color.icon.success500,
          notCheckedfill: themeUi.semantic.color.icon.secondary800
        },
        description: {
          color: themeUi.semantic.color.text.secondary100
        }
      }
    }
  }
};

export default theme;
